import { FC } from 'react'
import cn from './UserCard.module.css'
import { getAvatar } from '@/helpers/getAvatar'
import classNames from 'classnames'

interface IUserCard {
  user: IUser | null
  onClick?: () => void
  className?: string
  hidePersonalData?: boolean
  size?: 'small' | 'medium'
}

const UserCard: FC<IUserCard> = ({
  user,
  onClick,
  className,
  hidePersonalData = false,
  size = 'medium',
}) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        cn.wrapper,
        onClick && cn.active,
        size === 'small' && cn.small,
        className,
      )}
    >
      {size !== 'small' && (
        <img
          className={cn.icon}
          src={getAvatar(user?.avatar_path)}
          alt="user icon"
        />
      )}
      <div className={cn.infoWrapper}>
        <span className={cn.name}>{user?.name ?? '-'}</span>
        {!hidePersonalData && size !== 'small' && (
          <span className={cn.email}>{user?.email ?? '-'}</span>
        )}
      </div>
    </div>
  )
}

export default UserCard
